// extracted by mini-css-extract-plugin
export default {"TabsUi":"TabsUi_TabsUi__FbjaX","default":"TabsUi_default__IE7Km","newStyle":"TabsUi_newStyle__cbt7U","active":"TabsUi_active__ftyji","ant-space-item":"TabsUi_ant-space-item__Vksb-"};